<template>
  <div class="scheme-container">
    <van-button round type="primary" @click="handleClick">
      打开微信
    </van-button>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick() {
      window.open("weixin://dl/business/?t=uiuV7z3JWBg", "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.scheme-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
